(ns ycweb.app.website.dlp.widgets.timebasedspecial
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn calc-time-diff [end-date]
  (let [start-date (dt/plus (dt/now) (dt/hours 2))
        done? (dt/after? start-date end-date)
        interval-date (when-not done? (dt/interval start-date end-date))
        difference-ms (when interval-date (dt/in-millis interval-date))
        seconds (/ difference-ms 1000)
        minutes (/ seconds 60)
        hours (/ minutes 60)
        days (/ hours 24)]

    {:done? done?
     :days (str/format "%02d" (Math/floor days))
     :hours (str/format "%02d" (Math/floor (mod hours 24)))
     :minutes (str/format "%02d" (Math/floor (mod minutes 60)))
     :seconds (str/format "%02d" (Math/floor (mod seconds 60)))}))

(defn clear-countdown-interval [interval-id]
  #?(:cljs
     (.clearInterval js/window interval-id)))

(defn set-countdown-interval [app-atom end-date]
  #?(:cljs
     (.setInterval js/window
       (fn []
         (let [process-atom (cmn/process-cursor app-atom)
               calc-time (calc-time-diff end-date)]

           (when (:done? calc-time)
             (clear-countdown-interval (cmn/curact process-atom :countdown-interval-id)))

           (swap! process-atom assoc :countdown-timer calc-time)))
       1000)))

(defn start-countdown-timer [state widget-key]
  (let [[app-atom {:keys [properties]}] (:rum/args state)
        process-atom (cmn/process-cursor app-atom)
        count-down-date (get properties (keyword (str widget-key "/count-down-date")))
        interval-id
        (when (u/presence count-down-date)
          (set-countdown-interval app-atom count-down-date))]

    (when (u/presence count-down-date)
      (swap! process-atom assoc
        :countdown-timer (calc-time-diff count-down-date)
        :countdown-interval-id interval-id)))
  state)

(rum/defc countdown-timer < rum/reactive
  {:did-mount
   (fn [state]
     (start-countdown-timer state "time-based-special")
     state)}
  [app-atom {:keys [properties]}]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [done? days hours minutes seconds]} (cmn/curact process-atom :countdown-timer)
        {:time-based-special/keys
         [time-expired? products]} properties]
    [:<>
     (headings/heading
       (cond
         time-expired?
         "Time's up! Sorry, you missed it."

         (> (count products) 1)
         "Time remaining on current deals"

         :else
         "Time remaining on current deal")
       (u/maybe assoc
         {:type :h2 :size :small :center true}
         :class (when done? "text-status--error")))

     [:div.u-margin-bottom-30
      {:class (u/bem :countdown [(when done? :finish)])}
      [:span.countdown__item
       {:data-ttt "days"}
       days]
      [:span.countdown__divider ":"]
      [:span.countdown__item
       {:data-ttt "hrs"}
       hours]
      [:span.countdown__divider ":"]
      [:span.countdown__item
       {:data-ttt "min"}
       minutes]
      [:span.countdown__divider ":"]
      [:span.countdown__item
       {:data-ttt "sec"}
       seconds]]]))

(rum/defc time-based-specials < rum/reactive [app-atom _ {:keys [properties] :as component}]
  (let [{:time-based-special/keys
         [custom-description hide-time-based-products?
          custom-title tick-tick-tuesday? products time-expired?]} properties

        title
        (if (u/presence custom-title)
          custom-title
          "Sorry, you missed it this time.")]

    [:<>
     [:div {:class (u/bem :dlp-spacer [:medium-underline])}]
     (cond
       (empty? products)
       [:div
        {:class (u/bem :yc-section [:large])}
        (cond
          tick-tick-tuesday?
          [:div.u-block-center.u-max-width-640
           (headings/heading title
             {:type :h2
              :size :small
              :center true
              :class "u-text-red"
              :dangerouslySetInnerHTML? true})

           (cond
             (u/presence custom-description)
             [:p.yc-paragraph.u-text-center
              custom-description]

             :else
             [:p.yc-paragraph.u-text-center
              "Come back on Tuesday to see the next 24 hour offer. In the meantime, shop our other "
              [:a
               (merge
                 (urlstate/href-props app-atom "sale")
                 {:class (u/bem :text-link [:muted])})
               "great deals"]
              " and "
              [:a
               (merge
                 (urlstate/href-props app-atom "gifting")
                 {:class (u/bem :text-link [:muted])})
               "gifting options"]
              "."])]

          :else
          (feedback/feedback :warning "There are no limited time offers available at the moment."
            (list
              "Sorry, you missed it. We do, however, have other "
              [:a
               (merge
                 (urlstate/href-props app-atom "sale")
                 {:class (u/bem :text-link [:muted])})
               "great deals"]
              " and "
              [:a
               (merge
                 (urlstate/href-props app-atom "gifting")
                 {:class (u/bem :text-link [:muted])})
               "gifting options"]
              " for you.")))]

       :else
       [:div
        {:class (u/bem :yc-section [:large])}
        (countdown-timer app-atom component)

        (when-not hide-time-based-products?
          [:div
           {:class (u/bem :flex-grid-group [:flush])}
           (map
             (fn [product]
               [:div
                {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-4])}
                (cards/product-card-default app-atom product {:time-expired? time-expired?})])
             products)])])]))
